const collectors = [
  {
    id: 1,
    name: "",
    walletAddress: "0xC9eD24f32FE31a5157A73bafF4c619E5b87D8cd2",
    avatar:
      "https://f8n-production.imgix.net/creators/profile/sd6l5d906-td-artboard-32-gif-jpg-3191b1.jpg?q=45&w=180&h=180&auto=format%2Ccompress&fit=crop&dpr=2",

    statistics: {
      currency: "ETH",
      today: {
        creatorsSupported: 3,
        boughtNFTs: 3,
        totalSpent: 2.69,
      },
      week: {
        creatorsSupported: 2,
        boughtNFTs: 2,
        totalSpent: 2.69,
      },
      month: {
        creatorsSupported: 2,
        boughtNFTs: 2,
        totalSpent: 2.69,
      },
    },
  },
  {
    id: 2,
    name: "Jean-Michel Pailhon",
    walletAddress: "0xC9eD24f32FE31a5157A73bafF4c619E5b87D8cd2",
    avatar:
      "https://f8n-production.imgix.net/creators/profile/gip09hrbj-jmp-pp-png-xuwiuj.png?q=45&w=50&h=50&auto=format%2Ccompress&fit=crop&dpr=2",
      
    statistics: {
      currency: "ETH",
      today: {
        creatorsSupported: 1,
        boughtNFTs: 1,
        totalSpent: 3,
      },
      week: {
        creatorsSupported: 5,
        boughtNFTs: 5,
        totalSpent: 36.3,
      },
      month: {
        creatorsSupported: 5,
        boughtNFTs: 6,
        totalSpent: 46.3,
      },
    },
  },
  {
    id: 3,
    name: "jagged",
    walletAddress: "0xC9eD24f32FE31a5157A73bafF4c619E5b87D8cd2",
    avatar:
      "https://f8n-production.imgix.net/creators/profile/pwrn902eh-salarypepewow-png-41fib9.png?q=45&w=50&h=50&auto=format%2Ccompress&fit=crop&dpr=2",
      
    statistics: {
      currency: "ETH",
      today: {
        creatorsSupported: 2,
        boughtNFTs: 5,
        totalSpent: 1.33,
      },
      week: {
        creatorsSupported: 1,
        boughtNFTs: 1,
        totalSpent: 1.33,
      },
      month: {
        creatorsSupported: 74,
        boughtNFTs: 142,
        totalSpent: 85.7552,
      },
    },
  },
];

export default collectors;
